import React, { Component } from "react";

import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

import ReconciliationIcon from "mdi-material-ui/ChartBar";
// import CutPlanIcon from "mdi-material-ui/ContentCut";
// import RollPlanIcon from "mdi-material-ui/Layers";
// import FeedbackIcon from "@material-ui/icons/Feedback";
// import FabricReleaseIcon from "mdi-material-ui/FormatListChecks";
// import PartsRecuttingIcon from "mdi-material-ui/Receipt";
// import GarmentRecuttingIcon from "mdi-material-ui/FileDocument";
// import BundleIcon from "mdi-material-ui/BarcodeScan";

import { PageHeader } from "jazasoft";

import hasPrivilege from "../../../utils/hasPrivilege";
import { ResourceId, Scope } from "../../../utils/privilege";

const getReports = (roles, hasAccess) => {
  let reports = [];
  if (hasPrivilege(roles, hasAccess, ResourceId.MICRO, Scope.READ)) {
    reports.push({
      title: "Reconciliation Report",
      icon: <ReconciliationIcon />,
      path: "/reports/micro/reconciliation"
    });
  }

  if (hasPrivilege(roles, hasAccess, ResourceId.MICRO, Scope.READ)) {
    reports.push({
      title: "Daily Cutting Report",
      icon: <ReconciliationIcon />,
      path: "/reports/micro/cuttingReport"
    });
  }

  if (hasPrivilege(roles, hasAccess, ResourceId.MICRO, Scope.READ)) {
    reports.push({
      title: "Order Closure Pending Report",
      icon: <ReconciliationIcon />,
      path: "/reports/micro/closurePendingReport"
    });
  }

  if (hasPrivilege(roles, hasAccess, ResourceId.MICRO, Scope.READ)) {
    reports.push({
      title: "Roll Utilization Report",
      icon: <ReconciliationIcon />,
      path: "/reports/micro/rollUtilization"
    });
  }

  // if (hasPrivilege(roles, hasAccess, ResourceId.MICRO, Scope.READ)) {
  //   reports.push({ title: "Cut Plan Report", icon: <CutPlanIcon />, path: "/reports/micro/cutplan" });
  // }
  // if (hasPrivilege(roles, hasAccess, ResourceId.MICRO, Scope.READ)) {
  //   reports.push({ title: "Roll Plan Report", icon: <RollPlanIcon />, path: "/reports/micro/rollplan" });
  // }
  // if (hasPrivilege(roles, hasAccess, ResourceId.MICRO, Scope.READ)) {
  //   reports.push({ title: "Fabric Release Report", icon: <FabricReleaseIcon />, path: "/reports/micro/fabricRelease" });
  // }
  // if (hasPrivilege(roles, hasAccess, ResourceId.MICRO, Scope.READ)) {
  //   reports.push({ title: "Layslip Feedback Report", icon: <FeedbackIcon />, path: "/reports/micro/layslipFeedback" });
  // }
  // if (hasPrivilege(roles, hasAccess, ResourceId.MICRO, Scope.READ)) {
  //   reports.push({
  //     title: "Parts Recutting Report",
  //     icon: <PartsRecuttingIcon />,
  //     path: "/reports/micro/partsRecutting"
  //   });
  // }
  // if (hasPrivilege(roles, hasAccess, ResourceId.MICRO, Scope.READ)) {
  //   reports.push({
  //     title: "Garment Recutting Report",
  //     icon: <GarmentRecuttingIcon />,
  //     path: "/reports/micro/garmentRecutting"
  //   });
  // }
  // if (hasPrivilege(roles, hasAccess, ResourceId.MICRO, Scope.READ)) {
  //   reports.push({ title: "Bundle/Ticket Report", icon: <BundleIcon />, path: "/reports/micro/bundle" });
  // }

  return reports;
};

const styles = {
  root: {
    margin: "1.5em"
  },
  tile: {
    padding: "1em",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    cursor: "pointer"
  },
  icon: {
    margin: "0.5em"
  },
  title: {
    margin: "0.5em",
    fontWeight: "normal"
  }
};

class MicroReport extends Component {
  render() {
    const { classes, roles, hasAccess } = this.props;
    const reports = getReports(roles, hasAccess);
    return (
      <div>
        <PageHeader title="Micro Reports" />
        <div className={classes.root}>
          <Grid container spacing={2}>
            {reports.map((report, idx) => {
              return (
                <Grid key={idx} item xs={12} sm={3}>
                  <Paper className={classes.tile} square onClick={() => this.props.history.push(report.path)}>
                    <div>
                      {React.cloneElement(report.icon, {
                        className: classes.icon,
                        style: { fontSize: 28 },
                        color: "primary"
                      })}
                    </div>
                    <Typography component="div" variant="subtitle1" className={classes.title}>
                      {report.title}
                    </Typography>
                  </Paper>
                </Grid>
              );
            })}
          </Grid>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(MicroReport);
